import React from "react";
import { Controller } from "react-hook-form";
import DatePicker from "react-datepicker";
const refreshIcon = require("assets/img/icons/refresh.png");

export const FiltrosSolicitudes = ({ control, onRefresh, resetPage, searchPlaceholder }) => {
    return (
        <div className="formulario-fields-row align-items-end">
            <div className="formulario-field">
                <label htmlFor="search" className="m-0">
                    Buscar
                </label>
                <Controller
                    name="search"
                    control={control}
                    render={({ field }) => (
                        <input
                            type="text"
                            className="form-control"
                            placeholder={searchPlaceholder}
                            value={field.value}
                            onChange={(e) => {
                                field.onChange(e.target.value);
                                resetPage();
                            }}
                        />
                    )}
                />
            </div>
            <div className="formulario-field">
                <label htmlFor="fecha_inicial" className="m-0">
                    Fecha inicial
                </label>
                <Controller
                    name="fecha_inicial"
                    control={control}
                    render={({ field }) => (
                        <DatePicker
                            selected={field.value}
                            onChange={(date) => {
                                field.onChange(date);
                                resetPage();
                            }}
                            showPopperArrow={false}
                            dateFormat="DD/MM/YYYY"
                            placeholderText="Fecha de inicio"
                            maxDate={control._formValues.fecha_final}
                        />
                    )}
                />
            </div>
            <div className="formulario-field">
                <label htmlFor="fecha_final" className="m-0">
                    Fecha final
                </label>
                <Controller
                    name="fecha_final"
                    control={control}
                    render={({ field }) => (
                        <DatePicker
                            selected={field.value}
                            onChange={(date) => {
                                field.onChange(date);
                                resetPage();
                            }}
                            showPopperArrow={false}
                            dateFormat="DD/MM/YYYY"
                            placeholderText="Fecha final"
                            minDate={control._formValues.fecha_inicial}
                        />
                    )}
                />
            </div>
            <img
                src={refreshIcon}
                alt="Refrescar listado"
                title="Refrescar listado"
                className="action_img mb-1"
                onClick={() => {
                    onRefresh();
                }}
            />
        </div>
    );
};
